const OBFUSCATION_VERSION = 1
const OBFUSCATION_ENABLED = window.APP_CONFIG.VITE_API_OBFUSCATION_ENABLED === 'true'
const OBFUSCATION_KEY = window.APP_CONFIG.VITE_API_OBFUSCATION_KEY || ''

const textEncoder = new TextEncoder()
const textDecoder = new TextDecoder()

const isObfuscationEnabled = () => {
  return OBFUSCATION_ENABLED && OBFUSCATION_KEY.length > 0
}

const getObfuscationVersion = () => {
  return String(OBFUSCATION_VERSION)
}

const isObfuscationEnvelope = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return false
  }

  const keys = Object.keys(payload)
  return (
    keys.length === 2 &&
    keys.includes('v') &&
    keys.includes('data') &&
    payload.v === OBFUSCATION_VERSION
  )
}

const obfuscatePayload = (payload) => {
  const serializedPayload = JSON.stringify(payload)
  const obfuscatedData = xorBase64Encode(serializedPayload, OBFUSCATION_KEY)

  return {
    v: OBFUSCATION_VERSION,
    data: obfuscatedData
  }
}

const deobfuscatePayload = (payload) => {
  if (!isObfuscationEnvelope(payload)) {
    throw new Error('Invalid obfuscation envelope')
  }

  const decodedPayload = xorBase64Decode(payload.data, OBFUSCATION_KEY)
  return JSON.parse(decodedPayload)
}

const xorBase64Encode = (value, key) => {
  if (!key) {
    throw new Error('Missing VITE_API_OBFUSCATION_KEY')
  }

  const valueBytes = textEncoder.encode(value)
  const keyBytes = textEncoder.encode(key)
  const xored = new Uint8Array(valueBytes.length)

  for (let index = 0; index < valueBytes.length; index += 1) {
    xored[index] = valueBytes[index] ^ keyBytes[index % keyBytes.length]
  }

  return bytesToBase64Url(xored)
}

const xorBase64Decode = (value, key) => {
  if (!key) {
    throw new Error('Missing VITE_API_OBFUSCATION_KEY')
  }

  const encryptedBytes = base64UrlToBytes(value)
  const keyBytes = textEncoder.encode(key)
  const decoded = new Uint8Array(encryptedBytes.length)

  for (let index = 0; index < encryptedBytes.length; index += 1) {
    decoded[index] = encryptedBytes[index] ^ keyBytes[index % keyBytes.length]
  }

  return textDecoder.decode(decoded)
}

const bytesToBase64Url = (bytes) => {
  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

const base64UrlToBytes = (value) => {
  let base64 = value.replace(/-/g, '+').replace(/_/g, '/')
  while (base64.length % 4 !== 0) {
    base64 += '='
  }

  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }

  return bytes
}

export {
  deobfuscatePayload,
  getObfuscationVersion,
  isObfuscationEnabled,
  isObfuscationEnvelope,
  obfuscatePayload
}
